import { render } from "./HomeAside.vue?vue&type=template&id=1fc8a1f5&scoped=true"
import script from "./HomeAside.vue?vue&type=script&lang=js"
export * from "./HomeAside.vue?vue&type=script&lang=js"

import "./HomeAside.vue?vue&type=style&index=0&id=1fc8a1f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc8a1f5"]])

export default __exports__